module.exports = __webpack_public_path__ + "static/img/jieshu.2deecbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/jieshu.png
// module id = Rmaf
// module chunks = 24